/**
 * Get Kiosk Settings Use Case
 * Business logic for fetching kiosk settings
 */

import { KioskSettingsRepository } from '../data/kiosk-settings-repository';
import { KioskSettings } from '../types/kiosk-settings-types';

export class GetKioskSettingsUseCase {
  constructor(private readonly repository: KioskSettingsRepository) {}

  async execute(operatorId: number): Promise<KioskSettings> {
    return this.repository.getSettings(operatorId);
  }
}
